import React from 'react';
import * as style from './style.module.scss';
import SprucesLeftSVG from '../../images/spruces-left.svg';
import SprucesRightSVG from '../../images/spruces-right.svg';
import ForestSVG from '../../images/forest.svg';

export const SprucesLeft = () => {
  return (
    <figure
      className={`${style.trees} ${style.spruces} ${style.spruces__left}`}
    >
      <SprucesLeftSVG />
    </figure>
  );
};

export const SprucesRight = () => {
  return (
    <figure
      className={`${style.trees} ${style.spruces} ${style.spruces__right}`}
    >
      <SprucesRightSVG />
    </figure>
  );
};

export const Forest = () => {
  return (
    <figure className={`${style.trees} ${style.forest}`}>
      <ForestSVG />
    </figure>
  );
};
